import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'

export const MODULE_NAME = 'lk-passport'

export const LK_PASSPORT_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
  STATISTICS: `${MODULE_NAME}.stats`,
} as const

export const createLKPassportSchoolModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPassportModal" */
    './LKPassportModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKPassportContextualDataModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPassportContextualDataModal" */
    './components/ContextualData/LKPassportContextualDataModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
